import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';
import { DealsState } from '../reducers/deals.reducer';

export const getDealsState = createSelector(
    fromFeature.recruitingFeature,
    (state: fromFeature.RecruitingRootStoreState) => state.deals
);

export const selectDeals = createSelector(getDealsState, (state: DealsState) => state.deals);

export const selectDealsLookups = createSelector(getDealsState, (state: DealsState) => state.lookups);

export const selectDealsIsLoading = createSelector(getDealsState, (state: DealsState) => state.isLoading);

export const selectDealsGridSearchQuery = createSelector(getDealsState, (state: DealsState) => state.searchQuery);

export const selectDealsInfo = createSelector(getDealsState, (state: DealsState) => state.offerInfo);

export const selectExpertiseData = createSelector(getDealsState, (state: DealsState) => state.expertise);

export const selectRecruitingDealAlertData = createSelector(
    getDealsState,
    (state: DealsState) => state.recruitingDealAlertData
);

export const selectRecruitingDealsIsHubConnectionActive = createSelector(
    getDealsState,
    (state: DealsState) => state.isHubConnectionActive
);
